import httpClient from './httpClient';
import { getTenantConfig } from '../../config/tenantConfig';

const getBaseUrl = () => {
  const config = getTenantConfig();
  return config.api.witnessStatement;
};

export const statementTemplateService = {
  async listTemplates(status = null) {
    const params = new URLSearchParams();
    if (status) {
      params.append('status', status);
    }

    const url = `${getBaseUrl()}/templates${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await httpClient.get(url);
    return response; // httpClient already unwraps response.data
  },

  async getTemplate(templateId, version = null) {
    const params = new URLSearchParams();
    if (version) {
      params.append('version', version);
    }

    const url = `${getBaseUrl()}/templates/${templateId}${params.toString() ? `?${params.toString()}` : ''}`;
    const response = await httpClient.get(url);
    return response; // httpClient already unwraps response.data
  },

  async createTemplate(template) {
    const response = await httpClient.post(`${getBaseUrl()}/templates`, template);
    return response; // httpClient already unwraps response.data
  },

  async updateTemplate(templateId, updates) {
    const response = await httpClient.put(`${getBaseUrl()}/templates/${templateId}`, updates);
    return response; // httpClient already unwraps response.data
  },

  async activateTemplate(templateId, version = null) {
    const response = await httpClient.post(
      `${getBaseUrl()}/templates/${templateId}/activate`,
      { version }
    );
    return response; // httpClient already unwraps response.data
  },

  async archiveTemplate(templateId) {
    const response = await httpClient.post(`${getBaseUrl()}/templates/${templateId}/archive`);
    return response; // httpClient already unwraps response.data
  },

  async cloneTemplate(templateId, body = {}) {
    const response = await httpClient.post(`${getBaseUrl()}/templates/${templateId}/clone`, body);
    return response; // httpClient already unwraps response.data
  },

  async validateTemplate(templateId) {
    const response = await httpClient.post(`${getBaseUrl()}/templates/${templateId}/validate`);
    return response; // httpClient already unwraps response.data
  }
};
